import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Registry } from '@/registry.service';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { RentalAgencyService } from '@services/data-source-tables/rentals/rental-agency.service';
import { DialogRentalAgencyComponent } from '@pages/tables/rental-agency/dialog-rental-agency/dialog-rental-agency.component';
import { RentalAgencyModel } from '@/models/tables/rental-agency.model';

@Component({
  selector: 'app-button-detail-rental-agency',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDetailRentalAgencyComponent extends ButtonComponent implements OnInit {
  faIcon = faPenToSquare;
  private dialogOpened: MatDialogRef<any>;
  private rentalAgency: RentalAgencyModel;
  private rowData: any;

  constructor(
    protected router: Router,
    protected toastr: ToastrService,
    protected rentalAgencyService: RentalAgencyService,
    private dialog: MatDialog,
  ) {
    super(router, toastr);

    this.showIcon = true;
    this.additionalClass = 'py-0.5 px-2.5';
    this.toolTip = 'Dettaglio Agenzia Noleggio';
    this.smallBtn = true;
  }

  ngOnInit() {
    this.rentalAgency = <RentalAgencyModel>this.rowData;
  }

  /**
   * Open modal new detail page
   */
  public actionClick(): void {
    this.dialogOpened = this.dialog.open(DialogRentalAgencyComponent, {
      data: this.rentalAgency,
    });

    Registry.getInstance().set('DialogRentalAgencyComponentModify', this.dialogOpened);
  }
}
